require("!!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\script-loader\\addScript.js")(require("!!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\raw-loader\\index.js!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\ace-builds\\src-noconflict\\mode-powershell.js"))


//////////////////
// WEBPACK FOOTER
// ./~/ace-builds/src-noconflict/mode-powershell.js
// module id = 983626438511745
// module chunks = 0